import { useQuery } from "react-query";
import { fetchPandaDocStatus } from "../api/document";
/**
 * Custom hook to fetch the PandaDoc status of a document.
 * @param {string} documentId - The PandaDoc document id
 */
export const usePandaDocStatus = (documentId) => {
  return useQuery({
    queryKey: ["pandaDocStatus", documentId],
    queryFn: () => fetchPandaDocStatus(documentId),
    enabled: !!documentId, // Only run if documentId is truthy
  });
}